var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 76 76"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1778F2",
  d: "M38 0C17.012 0 0 17.012 0 38c0 18.752 13.586 34.32 31.445 37.426v-.131h.002V48.484h-9.17V37.998h9.17v-8.37c0-9.523 6.287-15.213 14.97-15.213 4.157 0 8.617.683 8.617.683v9.799h-4.905c-4.72 0-5.577 2.971-5.577 5.976v7.125h10.482l-1.833 10.486h-8.649v26.942C62.414 72.32 76 56.752 76 38 76 17.012 58.987 0 38 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.552 48.483H53.2l1.835-10.486H44.552v-7.125c0-3.005.859-5.976 5.578-5.976h4.905v-9.799s-4.462-.683-8.62-.683c-8.68 0-14.966 5.69-14.966 15.213v8.37h-9.174v10.486h9.174v26.941c2.13.373 4.315.575 6.548.575 2.239 0 4.425-.202 6.554-.575z"
})));
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.991c4397.svg";